//@ts-nocheck
import { Product } from "shared/api/middleware-api-client";
import { isTestEnvironment } from "shared/utils/checkEnvironment";

const zakelijkMappings = isTestEnvironment()
  ? {
      "op-dichte-wand": "6801f0c212ee5a0002d8dd49",
      "op-enkel-glas": "6908808c14c1460002efc72e",
      "op-dubbel-glas": "690880d514c1460002efc730",
    }
  : {
      "op-dichte-wand": "678519b6e0ae880002d6cc42",
      "op-enkel-glas": "6912ddd9c6b19400029a3bcd",
      "op-dubbel-glas": "6912de48c6b19400029a3bd4",
    };

const useUpdateZakelijkPayload = () => {
  const updateZakelijkPayload = (
    doorCode: string,
    businessProduct: Product,
  ) => {
    if (doorCode === "zakelijkkozijn") {
      businessProduct.doorLayout.id = "67569a31ae18e00002d4061a";
      businessProduct.label = "GewoonGers Zakelijk";
      businessProduct.measurements.easyToReach = false; //Default
      businessProduct.measurements.deliverInParts = false; //Default
      businessProduct.measurements.onLocation = false; //Default
      businessProduct.measurements.extraFloor = true; //Default
      businessProduct.measurements.typePlafond = "beton"; //Default
      businessProduct.measurements.view = "zelfmontage"; //Default
      businessProduct.measurements.leftStelprofiel = false; //Default
      businessProduct.measurements.rightStelprofiel = false; //Default
      businessProduct.measurements.hasFloorHeating = false; //Default
      businessProduct.measurements.smokeAlarm = false; //Default
      businessProduct.measurements.pipe = false; //Default

      const frameConnection =
        businessProduct.measurements.frameConnection ?? "op-dichte-wand";
      businessProduct.doorType.id = zakelijkMappings[frameConnection];
      businessProduct.measurements.frameConnection = undefined;
    } else if (doorCode === "kaderdeur") {
      businessProduct.doorLayout.id = "67569a31ae18e00002d4061a";
      businessProduct.label = "GewoonGers Zakelijk";

      /**
                    Loopdeur: 3 if left, 5 if right
       **/
      businessProduct.measurements.activeDoorIndex =
        businessProduct.measurements.rotation === "left" ? 3 : 5;
      businessProduct.measurements.frameType = "steel";
      businessProduct.measurements.easyToReach = false; //Default
      businessProduct.measurements.deliverInParts = false; //Default
      businessProduct.measurements.onLocation = false; //Default
      businessProduct.measurements.extraFloor = true; //Default
      businessProduct.measurements.scheluwHangTop = 0; //Default
      businessProduct.measurements.scheluwHangBottom = 0; //Default
      businessProduct.measurements.scheluwSluitTop = 0; //Default
      businessProduct.measurements.scheluwSluitBottom = 0; //Default
      businessProduct.measurements.dagschoothoogte = 1050; //Default
      businessProduct.measurements.hinge1 = 340; //Default
      businessProduct.measurements.hinge2 = 540; //Default
    } else if (doorCode === "dubbelekaderdeur") {
      businessProduct.doorLayout.id = "67569a31ae18e00002d4061a";

      businessProduct.label = "GewoonGers Zakelijk";
      businessProduct.measurements.activeDoorIndex =
        businessProduct.measurements.rotation === "left" ? 3 : 5;
      businessProduct.measurements.frameType = "steel";
      businessProduct.measurements.hingeAmount = 3;
      businessProduct.measurements.easyToReach = false;
      businessProduct.measurements.deliverInParts = false;
      businessProduct.measurements.onLocation = false;
      businessProduct.measurements.extraFloor = true;
      businessProduct.measurements.scheluwHangTop = 0;
      businessProduct.measurements.scheluwHangBottom = 0;
      businessProduct.measurements.scheluwSluitTop = 0;
      businessProduct.measurements.scheluwSluitBottom = 0;
      businessProduct.measurements.dagschoothoogte = 1050;
      businessProduct.measurements.hinge1 = 340;
      businessProduct.measurements.hinge2 = 540;
    }
  };

  return {
    updateZakelijkPayload,
  };
};

export default useUpdateZakelijkPayload;
